<template>
  <right-menu-item
    v-if="show"
    @click="click"
    :text="$t('Show approvals')"
    icon="check"
  />
</template>

<script>
import { mapStores } from 'pinia'
import useBcLinkStore from '@/frontapp/store/bcLink'
import useBcFolderStore from '@/frontapp/store/bcFolder'
import openApproval from '../../mixins/actions/OpenApproval'
import DocumentStore from '@/frontapp/mixins/DocumentStore'

export default {
  mixins: [
    DocumentStore,
  ],
  computed: {
    ...mapStores(useBcFolderStore, useBcLinkStore),
    show () {
      return this.bcDocumentStore.document?.approval !== null
    },
  },
  methods: {
    click() {
      openApproval(this.$store, this.$formValues, this.bcDocumentStore.document.approval, this.bcDocumentStore.document.id, this.bcDocumentStore.document.bc_document_rev_id, this.bcDocumentStore.edit)
    }
  }
}
</script>

<style lang="scss" scoped></style>
